import React from 'react';
import '../index.css';

const PrivacyPolicy = () => {
  return (
    <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '50px',
        animation: 'fadeInUp 0.6s ease-out'
      }}>
        <h1 style={{
          color: 'var(--text-accent)',
          fontSize: '42px',
          fontWeight: '800',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '2px'
        }}>
          Privacy Policy
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: '16px',
          lineHeight: '1.6'
        }}>
          Last Updated: December 15, 2025
        </p>
      </div>

      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        padding: '40px',
        border: '1px solid var(--border)',
        lineHeight: '1.8',
        fontSize: '16px',
        animation: 'fadeInUp 0.8s ease-out'
      }}>
        
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Introduction
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            At GamersUnion, we take your privacy seriously. This Privacy Policy explains how we collect, use, 
            and protect your personal information when you use our platform. By using GamersUnion, you agree 
            to the terms outlined in this policy.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Information We Collect
          </h2>
          
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Account Information
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              When you create an account, we collect basic information including your username, email address, 
              and password (stored securely and encrypted). If you choose to add profile details such as a bio, 
              profile picture, or social media links, we store this information as well.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Usage Data
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              We automatically collect certain information about how you interact with our platform. This includes 
              your IP address, browser type, device information, pages visited, time spent on the site, and 
              interactions with features like giveaways, reviews, and community posts. This helps us improve the 
              platform and understand how users engage with our services.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              User-Generated Content
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              Any content you create on GamersUnion, including reviews, community posts, comments, showcase items, 
              and messages, is stored on our servers. Keep in mind that most content is public and visible to other users.
            </p>
          </div>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            How We Use Your Information
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
            We use the information we collect to:
          </p>
          <ul style={{ color: 'var(--text)', marginLeft: '24px', marginBottom: '16px' }}>
            <li style={{ marginBottom: '8px' }}>Provide and maintain the GamersUnion platform</li>
            <li style={{ marginBottom: '8px' }}>Process your account registration and authentication</li>
            <li style={{ marginBottom: '8px' }}>Enable features like points, achievements, giveaways, and community interactions</li>
            <li style={{ marginBottom: '8px' }}>Send important notifications about your account, giveaway wins, or platform updates</li>
            <li style={{ marginBottom: '8px' }}>Analyze usage patterns to improve our services and develop new features</li>
            <li style={{ marginBottom: '8px' }}>Prevent fraud, spam, and abuse on the platform</li>
            <li style={{ marginBottom: '8px' }}>Comply with legal obligations and enforce our terms of service</li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Information Sharing
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We do not sell your personal information to third parties. We may share your information only in the 
            following circumstances:
          </p>
          <ul style={{ color: 'var(--text)', marginLeft: '24px', marginBottom: '16px' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Public Profile Information:</strong> Your username, profile picture, bio, and public activity 
              are visible to other users by default
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Service Providers:</strong> We use trusted third-party services (such as hosting providers, 
              email services, and analytics tools) to operate the platform. These providers only access information 
              necessary to perform their functions
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Legal Requirements:</strong> We may disclose information if required by law, legal process, 
              or to protect the rights and safety of GamersUnion and its users
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Cookies and Tracking
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            GamersUnion uses cookies and similar tracking technologies to maintain your session, remember your 
            preferences, and analyze platform usage. Cookies are small text files stored on your device that help 
            us provide a better user experience. You can control cookie preferences through your browser settings, 
            though disabling cookies may limit certain features.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Data Security
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We implement reasonable security measures to protect your information from unauthorized access, 
            alteration, disclosure, or destruction. This includes encrypting passwords, using secure connections 
            (HTTPS), and regularly reviewing our security practices. However, no method of transmission over the 
            internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Your Rights and Choices
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
            You have certain rights regarding your personal information:
          </p>
          <ul style={{ color: 'var(--text)', marginLeft: '24px', marginBottom: '16px' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Access and Update:</strong> You can access and update your account information through your 
              profile settings at any time
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Account Deletion:</strong> You can request deletion of your account by contacting us. Some 
              information may be retained for legal or legitimate business purposes
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Marketing Communications:</strong> You can opt out of promotional emails by using the 
              unsubscribe link in those messages
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Data Portability:</strong> You can request a copy of your personal data in a structured, 
              commonly used format
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Third-Party Links
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            GamersUnion may contain links to external websites, including game stores, developer pages, and affiliate 
            links. We are not responsible for the privacy practices of these third-party sites. We encourage you to 
            review their privacy policies before providing any personal information.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Children's Privacy
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            GamersUnion is not intended for users under the age of 13. We do not knowingly collect personal 
            information from children under 13. If we become aware that a child under 13 has provided us with 
            personal information, we will take steps to delete such information promptly.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Changes to This Policy
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We may update this Privacy Policy from time to time to reflect changes in our practices or legal 
            requirements. When we make significant changes, we'll notify you through the platform or via email. 
            Your continued use of GamersUnion after such changes constitutes acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Contact Us
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            If you have questions or concerns about this Privacy Policy or how we handle your data, please reach 
            out to us through our contact page or via Twitter at @AlonelyCat31.
          </p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
